// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"_15802","header":"_4095","bdb":"_2706","listWrap":"_4804","ios":"_15860"};